<template>
  <CardModule class="mt-6" :title="$t('registrations.producers.documents')">
    <div class="search-forms">
      <v-row>
        <v-col cols="12" sm="6">
          <v-select
            outlined
            dense
            color="tertiary"
            class="rounded-lg"
            :label="$t('registrations.producers.document-type')"
            item-text="key"
            item-value="value"
            v-model="$loja_gerenciar.cadastro.documentos.documento"
            type="text"
            :no-data-text="$t('registrations.no-results-found')"
            persistent-hint
            :items="filteredData"
            :hint="
              $loja_gerenciar.cadastro.dados_cadastrais.pessoa == 'FISICA'
                ? $t('registrations.producers.document-type-hint-1')
                : $t('registrations.producers.document-type-hint-2')
            "
          >
            <template v-slot:item="{ item }">
              {{ translatedDocuments(item.key, item.value) }}
            </template>
            <template v-slot:selection="{ item }">
              {{ translatedDocuments(item.key, item.value) }}
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="6">
          <v-file-input
            outlined
            dense
            clear-icon="mdi-close-circle-outline"
            show-size
            class="rounded-lg"
            hide-details
            accept=".pdf"
            append-icon="mdi-paperclip"
            prepend-icon=""
            :placeholder="
              $t('registrations.producers.click-to-import-document')
            "
            clearable
            v-model="
              $loja_gerenciar.cadastro.documentos.documento_upload.object
            "
            persistent-hint
            :hint="`${$t('registrations.producers.file-format')}: PDF`"
            @click:clear="clearDOC()"
            @change="
              getDOC(
                $loja_gerenciar.cadastro.documentos.documento_upload.object
              )
            "
          >
          </v-file-input>
        </v-col>
      </v-row>
      <v-row no-gutters class="justify-end">
        <BaseButton
          variant="filter"
          class="my-4 my-sm-0"
          :loading="$loja_gerenciar.cadastro.documentos.loading_documento"
          @click="
            uploadDOC($loja_gerenciar.cadastro.documentos.documento_upload.doc)
          "
        >
          {{ $t("registrations.producers.upload") }}
          <v-icon class="ml-2">mdi-upload</v-icon>
        </BaseButton>
      </v-row>
      <div
        class="documentos-table"
        v-if="
          $loja_gerenciar.cadastro.dados_cadastrais.pessoa === 'FISICA' &&
          $loja_gerenciar.cadastro.documentos &&
          $loja_gerenciar.cadastro.documentos.documento_array_pf &&
          $loja_gerenciar.cadastro.documentos.documento_array_pf.length == 0
        "
      >
        <span>{{ $t("registrations.no-results-found") }}</span>
      </div>
      <div
        class="documentos-table"
        v-else-if="
          $loja_gerenciar.cadastro.dados_cadastrais.pessoa === 'JURIDICA' &&
          $loja_gerenciar.cadastro.documentos &&
          $loja_gerenciar.cadastro.documentos.documento_array_pj &&
          $loja_gerenciar.cadastro.documentos.documento_array_pj.length == 0
        "
      >
        <span>{{ $t("registrations.no-results-found") }}</span>
      </div>
      <v-simple-table fixed-header class="documentos-table mt-4" v-else>
        <template v-slot:default>
          <thead>
            <tr>
              <th
                v-for="(header, index) in headersDocs"
                :key="index"
                class="text-center table-header"
              >
                {{ header.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(doc, index) in tipoPessoaTable" :key="index">
              <td class="text-center">{{ Object.keys(doc)[0] }}</td>
              <td class="text-center">{{ Object.values(doc)[0] }}</td>
              <td class="table-actions">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      v-bind="attrs"
                      class="mr-2"
                      v-on="on"
                      width="30"
                      small
                      icon
                      dark
                      @click="previewDOC(Object.values(doc)[0])"
                    >
                      <v-icon>mdi-file-eye-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("registrations.producers.view") }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      v-bind="attrs"
                      v-on="on"
                      width="30"
                      small
                      icon
                      dark
                      @click="
                        $loja_gerenciar.remover(
                          index,
                          'document',
                          Object.keys(doc)[0],
                          $t(
                            'registrations.producers.delete-document-confirmation'
                          )
                        )
                      "
                    >
                      <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("registrations.delete") }}</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </CardModule>
</template>
<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
export default {
  name: "Documents",
  mixins: [LojasGerenciarMixins],
  components: {
    CardModule: () => import("@/components/cards/CardModule.vue"),
    BaseButton: () => import("@/components/forms/BaseButton.vue"),
  },
  computed: {
    filteredData() {
      if (this.$loja_gerenciar.cadastro.dados_cadastrais.pessoa == "FISICA") {
        return this.$loja_gerenciar.tipo_docs_pf.filter(
          item => item.show === true
        );
      } else {
        return this.$loja_gerenciar.tipo_docs_pj.filter(
          item => item.show === true
        );
      }
    },
    tipoPessoaTable() {
      if (this.$loja_gerenciar.cadastro.dados_cadastrais.pessoa === "FISICA") {
        return this.$loja_gerenciar.cadastro.documentos.documento_array_pf;
      } else {
        return this.$loja_gerenciar.cadastro.documentos.documento_array_pj;
      }
    },
  },
  methods: {
    translatedDocuments(key, value) {
      switch (value) {
        case "pdf_comprovante_endereco":
          return this.$t("registrations.producers.proof-of-residence");
        case "pdf_documento":
          return this.$t("registrations.producers.document-options");
        case "pdf_proposta_comercial":
          return this.$t("registrations.producers.commercial-proposal");
        case "pdf_contrato_social":
          return this.$t("registrations.producers.social-contract");
        case "pdf_procuracao":
          return this.$t("registrations.producers.letter-of-attorney");
        default:
          return key;
      }
    },
  },
  watch: {
    "$loja_gerenciar.cadastro.documentos.documento_array_pj"(e) {
      e.forEach(obj => {
        const docsFilter = this.$loja_gerenciar.tipo_docs_pj.find(
          o => Object.keys(obj)[0] === o.value
        );
        if (docsFilter) {
          this.$loja_gerenciar.tipo_docs_pj.map((item, index) => {
            if (docsFilter.value == item.value) {
              this.$loja_gerenciar.tipo_docs_pj[index].show = false;
            }
          });
        }
      });
    },
    "$loja_gerenciar.cadastro.documentos.documento_array_pf"(e) {
      e.forEach(obj => {
        const docsFilter = this.$loja_gerenciar.tipo_docs_pf.find(
          o => Object.keys(obj)[0] === o.value
        );
        if (docsFilter) {
          this.$loja_gerenciar.tipo_docs_pf.map((item, index) => {
            if (docsFilter.value === item.value) {
              this.$loja_gerenciar.tipo_docs_pf[index].show = false;
            }
          });
        }
      });
    },
  },
  mounted() {
    this.$loja_gerenciar.tipo_docs_pf.forEach((obj, index) => {
      const docsFilter =
        this.$loja_gerenciar.cadastro.documentos.documento_array_pf.find(
          o => Object.keys(o)[0] === obj.value
        );
      if (docsFilter) {
        this.$loja_gerenciar.tipo_docs_pf[index].show = false;
      }
    });
    // } else {
    this.$loja_gerenciar.tipo_docs_pj.forEach((obj, index) => {
      const docsFilter =
        this.$loja_gerenciar.cadastro.documentos.documento_array_pj.find(
          o => Object.keys(o)[0] === obj.value
        );
      if (docsFilter) {
        this.$loja_gerenciar.tipo_docs_pj[index].show = false;
      }
    });
    // }
  },
  destroyed() {
    this.$loja_gerenciar.limpaFormularioDeLoja();
  },
};
</script>

<style>
.documentos-table {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 1.25rem !important;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}
</style>
